/**
 * Genesis hero/background personas — mirrors scripts/seed-genesis-state.ts (password: Test1234!).
 * Shown on the login page in dev/QA for quick tester access.
 */
export const GENESIS_TEST_PASSWORD = 'Test1234!';

export const GENESIS_TEST_ACCOUNTS = [
  {
    label: 'Merchant Alpha (hero)',
    email: 'merchant_alpha@test.local',
    role: 'Merchant · Anvil #1',
  },
  {
    label: 'Runner Bravo (hero)',
    email: 'runner_bravo@test.local',
    role: 'Runner · Anvil #2',
  },
  {
    label: 'Background User 1',
    email: 'user1@test.local',
    role: 'Web2 only',
  },
  {
    label: 'Background User 2',
    email: 'user2@test.local',
    role: 'Web2 only',
  },
  {
    label: 'Background User 3',
    email: 'user3@test.local',
    role: 'Web2 only',
  },
  {
    label: 'Background User 4',
    email: 'user4@test.local',
    role: 'Web2 only',
  },
  {
    label: 'Background User 5',
    email: 'user5@test.local',
    role: 'Web2 only',
  },
  {
    label: 'Inactive Web3 User 3',
    email: 'web3_inactive_3@test.local',
    role: 'Anvil #3',
  },
  {
    label: 'Inactive Web3 User 4',
    email: 'web3_inactive_4@test.local',
    role: 'Anvil #4',
  },
  {
    label: 'Inactive Web3 User 5',
    email: 'web3_inactive_5@test.local',
    role: 'Anvil #5',
  },
];

export const shouldShowGenesisTestAccounts = () =>
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_SHOW_GENESIS_CREDENTIALS === 'true';
